import { setLocale } from 'yup';
import { suggestive } from 'yup-locale-ja';

/**
 * yup のメッセージを日本語にする。
 *
 * **`notType` だけは自前で足す。** `yup-locale-ja` は「概念が利用者に伝わりにくい」という方針で
 * `notType` を意図的に持っていない（`yup-locale-ja/esm/suggestive.js:1` のコメント。
 * 「Write your own if you need that one」）。放置すると型キャストに失敗したときだけ
 * **Yup 既定の英文がそのまま画面に出る**。
 *
 * ```
 * seirekiYear must be a `number` type, but the final value was: `NaN` (cast from the value ``).
 * ```
 *
 * 数値の `<select>` / `<input type="number">` を未選択・空にすると空文字が渡るため、
 * `.typeError()` を書いていないフォームはどこでもこれを踏む。
 */
export default defineNuxtPlugin(() => {
  setLocale({
    ...suggestive,
    mixed: {
      ...suggestive.mixed,
      notType: ({ label, type }) => {
        const subject = label ? `${label}には` : '';
        if (type === 'number') return `${subject}数値を入力してください`;
        if (type === 'date') return `${subject}正しい日付を入力してください`;
        return `${subject}正しい値を入力してください`;
      },
    },
  });
});
